import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditImpresionOnlineComponent } from "./edit-impresion-online/edit-impresion-online.component";

@Component({
  selector: "app-categorias",
  templateUrl: "./impresion-online.component.html",
  styleUrls: ["./impresion-online.component.scss"],
})
export class ImpresionOnlineComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  openPanel() {
    this.customanpanel = EditImpresionOnlineComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
